module.exports = __webpack_public_path__ + "static/media/covid-declaration.36106cc8.svg";